import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdSearch,
  MdWarning,
  MdAssignment,
  MdStore,
  MdImage,
  MdEmail,
  MdAdd,
  MdInfo,
  MdCheckCircle,
  MdReport,
  MdCompare,
  MdListAlt,
  MdShoppingCart,
  MdVerifiedUser,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import Keyword from "views/admin/keyword";
import Uncrawled from "views/admin/Uncrawled";
import Suspicious from "views/admin/suspicious";
import TestProduct from "views/admin/testProducts";
import DetectedProducts from "views/admin/Detected Product";
import Sellers from "views/admin/sellers";
import Lookalike from "views/admin/lookalike";
import ProductInfo from "views/admin/product_info";
import BrandAcquisition from "./BA/BrandAcquisition";
import CounterfeitSellers from "views/admin/CounterfeitSellers/index";
import OriginalImages from "views/admin/originalImages";
import AddUrlManually from "views/admin/addUrlManually";
import EmailReport from "views/admin/EmailReport";
import LookalikeInfringement from "views/admin/LookalikeInfringement";
import GlobalProducts from "views/admin/GlobalProducts";





import Profile from "views/admin/profile";
import DataTables from "views/admin/dataTables";

// Auth Imports
import SignInCentered from "views/auth/signIn";
import CounterfeitSellerBrands from "views/admin/BrandWise";
import RegisterPage from "views/auth/signup";
import { IoMdGlobe } from "react-icons/io";


const routes = [
  {
    name: "Overview",
    layout: "/admin",
    path: "/dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    name: "Keywords",
    layout: "/admin",
    path: "/keywords",
    icon: (
      <Icon
        as={MdSearch}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Keyword,
  },
  {
    isAdmin: true,
    name: "Add URLs manually",
    layout: "/admin",
    path: "/addurlmanually",
    icon: (
      <Icon
        as={MdAdd}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: AddUrlManually,
    secondary: true,

  },
  {
    isAdmin: true,
    name: "Uncrawled Products",
    layout: "/admin",
    path: "/uncrawled",
    icon: (
      <Icon
        as={MdListAlt}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Uncrawled,
    secondary: true,
  },
  {
    name: "Detected",
    layout: "/admin",
    path: "/products",
    icon: (
      <Icon
        as={MdCheckCircle}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: DetectedProducts,
    secondary: true,
  },
  {
    name: "Suspicious",
    layout: "/admin",
    path: "/suspicious",
    icon: (
      <Icon
        as={MdWarning}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Suspicious,
    secondary: true,
  },
  {
    isAdmin: true,
    name: "Email Report",
    layout: "/admin",
    path: "/mail-report",
    icon: (
      <Icon
        as={MdEmail}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: EmailReport,
    secondary: true,
  },

  // {
  //   name: "Sign In",
  //   layout: "/auth",
  //   path: "/sign-in",
  //   icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
  //   component: SignInCentered,
  // },

  {
    name: "Test Purchase",
    layout: "/admin",
    path: "/test",
    icon: (
      <Icon
        as={MdShoppingCart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: TestProduct,
    secondary: true,
  },
  {
    name: "Sellers",
    layout: "/admin",
    path: "/sellers",
    icon: (
      <Icon
        as={MdStore}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Sellers,
    secondary: true,
  },
  {
    name: "Product Info",
    layout: "/admin",
    path: "/productinfo",
    icon: (
      <Icon
        as={MdInfo}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: ProductInfo,
    secondary: true,
  },
  {
    isAdmin: true,
    name: "Check Lookalike",
    layout: "/admin",
    path: "/lookalike",
    icon: (
      <Icon
        as={MdCompare}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Lookalike,
    secondary: true,
  },

  {
    isAdmin: true,
    name: "Original Images",
    layout: "/admin",
    path: "/original",
    icon: (
      <Icon
        as={MdImage}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: OriginalImages,
    secondary: true,
  },



  {
    isAdmin: true,
    name: "Counterfeit Sellers",
    layout: "/admin",
    path: "/counterfeit_sellers",
    icon: (
      <Icon
        as={MdReport}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: CounterfeitSellers,
    secondary: true,
  },

  {
    isAdmin: true,
    name: "Lookalike Infringement",
    layout: "/admin",
    path: "/infringe",
    icon: (
      <Icon
        as={MdCompare}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: LookalikeInfringement,
    secondary: true,
  },
  {
    isAdmin: true,
    name: "Global Products",
    layout: "/admin",
    path: "/globalproducts",
    icon: (
      <Icon
        as={IoMdGlobe}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: GlobalProducts,
    secondary: true,
  },

  // not to display in sidebar
  {
    name: "BrandWise Counterfeit",
    layout: "/admin",
    path: "/brands",
    icon: <Icon as={MdVerifiedUser} width='20px' height='20px' color='inherit' />,
    component: CounterfeitSellerBrands,
  }


  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "/profile",
  //   icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
  //   component: Profile,
  // },

];

const extraRoutes = [
  {
    name: "Sign Up",
    layout: "/auth",
    path: "/sign-up",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: RegisterPage,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: SignInCentered,
  }
];

export default routes;
export { extraRoutes };


